function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fillRule: "nonzero",
  stroke: "#FFFFFF",
  strokeWidth: 2
}, React.createElement("g", null, React.createElement("circle", {
  cx: 17.5,
  cy: 17.5,
  r: 16.5
}), React.createElement("path", {
  d: "M14.5833333,11.2 L14.5833333,23.7406165",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M20.4166667,11.2 L20.4166667,23.7406165",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));

const SvgPauseSessionIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "35px",
  height: "35px",
  viewBox: "0 0 35 35",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgPauseSessionIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pause-session-icon.8378b824.svg";
export { ForwardRef as ReactComponent };